<template>
  <li class="item" title="Exportar">
    <a href="javascript:;" @click="modalOpen('code');codeSetupBox(boxActive)">
      <i class="kp-panel-import"></i>
      <span class="txt">{{ $t('general.actions.export') }}</span>
    </a>
  </li>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  methods: mapActions([
    'modalOpen',
    'codeSetupBox',
  ]),
  computed: mapGetters({
    boxActive: 'boxActive',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Export.vue?4a2a73eb
 **/